// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c3de89a8","239":"2767480a","455":"c55ac413"}[chunkId] + ".chunk.js";
};